<template>
    <div :style="{backgroundColor:getSuccessSubCourseColor()}">
        <HeaderNav v-if="!isWeixinBrowser()" :beforecolor="'#fff'" :backcolor="getSuccessBuyButtonColor()"
                   @returnBack="goToBack"/>
        <div class="imgLazyLoadHead"><img v-bind:src="getheadImage()" alt=""/></div>
        <div class="lesson_introduce" :style="{color:getSuccessCourseColor()}" @click="lessonIntroduceClick">
            <div class="lesson_introduce_content">
                <img src="../../../assets/reading_before_tip.png" alt=""/>
                <div>课程介绍</div>
                <div class="clear"></div>
            </div>
        </div>
        <!--试听-->
        <SuccessBeforeItem :style="{'padding-top':'10px'}" :lessonArray="objSuccessCourseHomeInfo.freeTrial" :selectedLessonPk="freeTrialSelectedPk.toString()"
                           :isFreeTrial="'1'" @buyTipClick="freebuyTipClick" @lessonItemClick="freeLessonItemClick"/>
        <div class="all_lesson" :style="{color:getSuccessCourseColor()}">
            <div class="all_lesson_line" :style="{backgroundColor:getSuccessCourseColor(), 'margin-right': '10px'}"></div>
            <div class="all_lesson_title">全部课程</div>
            <div class="all_lesson_line" :style="{backgroundColor:getSuccessCourseColor(), 'margin-left': '10px'}"></div>
        </div>
        <div class="course_list_content">
            <div class="group_lesson_item" :style="{'padding-top':index === 0 ? '5px' : '30px'}" v-for="(item,index) in objSuccessCourseHomeInfo.groupLesson" :key="index">
                <div class="group_lesson_title">
                    <div class="chinese" :style="{color:getSuccessCourseColor()}">{{item.readingSkillsChinese}}</div>
                    <div class="english" :style="{color:getSuccessCourseColor()}">{{item.readingSkillsEnglish}}</div>
                </div>
                <SuccessBeforeItem :lessonArray="item.lessonArray" :selectedLessonPk="selectedLessonPk.toString()"
                                   @buyTipClick="buyTipClick" @lessonItemClick="lessonItemClick"/>
            </div>
            <div class="lesson_list_bottom" :style="{'height': adapterMarginBottom()}"></div>
        </div>
        <div class="bottom_tool" :style="{height: adapterBigScreenHeight()}">
            <div class="tabbar_buy" :style="{'background-color':'#dd2126', 'margin-bottom': adapterBigScreen()}" @click="buyClick">
                <span>购买课程</span>
                <div class="go">立即前往</div>
            </div>
        </div>
    </div>
</template>
<script>
    import {MessageBox} from "mint-ui";

    export default {
        data() {
            return {
                selected: '1',
                courseId: parseInt(this.$route.query.courseId),
                objSuccessCourseHomeInfo: {},
                totalPartCount: 4,
                WordsGlossaryArray: [],
                selectedLessonPk:0,
                freeTrialSelectedPk:0
            }
        },
        watch : {
            selected(newV){
                window.console.log(newV);

                if (parseInt(newV) === 2) {
                    this.guideWordsAfterClick();
                }
            }
        },
        methods: {
            goToBack() {
                let that = this;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid;

                if (!this.isEmpty(token) && !this.isEmpty(userid) && token.length > userid.length) {
                    if (this.isAppIos()) {
                        var vUrl = "readingclubapp:gobackMyCourse";
                        document.location = vUrl;
                    }

                    if (this.isAppAndroid()) {
                        window.note.gobackMyCourse();
                    }
                } else {
                    that.goBack(this.$router);
                }
            },
            freeLessonItemClick:function(pk) {
                if (this.freeTrialSelectedPk === pk){
                    return;
                }

                this.freeTrialSelectedPk = pk;
            },
            lessonItemClick:function(pk) {
                if (this.selectedLessonPk === pk){
                    return;
                }

                this.selectedLessonPk = pk;
            },
            buyClick:function(){
                let that = this;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid;

                if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    if (that.isAppIos()) {
                        let vYouZanUrl = this.objSuccessCourseHomeInfo.buyUrl.replace(new RegExp('https:','g'), '');
                        let vUrl = "readingclubapp:buySuccessBefore:" + that.courseId + ":" + vYouZanUrl;
                        document.location = vUrl;
                    }

                    if (that.isAppAndroid()) {
                        window.note.buySuccessBefore(that.courseId, this.objSuccessCourseHomeInfo.buyUrl);
                    }
                } else {
                    this.$router.push({name: 'excessivebuy', query: {buyUrl: this.objSuccessCourseHomeInfo.buyUrl}});
                }
            },
            freebuyTipClick:function(type, pk){
                if (type === 1) {
                    this.$router.push({name: "SLesson", query: {lessonId: pk}})
                }else if (type === 2) {
                    this.$router.push({name: "SQuestion", query: {lessonId: pk}})
                } else if (type === 3) {
                    this.$router.push({name: "SStrategy", query: {lessonId: pk}})
                }
            },
            buyTipClick:function(type, pk){
                window.console.log(type + "," + pk);
                MessageBox.confirm('', {
                    message: ' ',
                    title: '要先购买才能上课哦～快去购买吧！',
                    showConfirmButton:false,
                    showCancelButton:true,
                    closeOnClickModal: false,
                    cancelButtonClass:'cancelButton',
                    confirmButtonClass:'confirmButton',
                    cancelButtonText:'知道了'
                });
            },
            lessonIntroduceClick:function(){
                this.$router.push({name: 'pageView', query: {url: "https://www.xiaohuasheng.cn/mtesthome_"+ 259310 +"/come_1"}});
            },
            getheadImage:function(){
                return require('@/assets/s' + this.courseId + '.jpg');
            },
            lessonClick: function (pk) {
                this.$router.push({
                    name: 'wordLesson',
                    query: {courseId: this.courseId, lessonId: pk}
                });
            },
            scrollToPositin(section) {
                document.getElementById('section_' + section).scrollIntoView();
            },
            adapterBigScreen: function () {
                if (this.isWeixinBrowser() || this.isAppAndroid()) {
                    return "0px";
                }

                const rate = window.screen.height / window.screen.width;
                let limit =  window.screen.height === window.screen.availHeight ? 1.8 : 1.65; // 临界判断值

                return rate > limit ? "36px" : "0px";
            },
            adapterBigScreenHeight: function () {
                if (this.isWeixinBrowser() || this.isAppAndroid()) {
                    return "80px";
                }

                const rate = window.screen.height / window.screen.width;
                let limit =  window.screen.height === window.screen.availHeight ? 1.8 : 1.65; // 临界判断值

                return rate > limit ? "86px" : "50px";
            },
            adapterMarginBottom: function () {
                if (this.isWeixinBrowser() || this.isAppAndroid()) {
                    return "80px";
                }

                const rate = window.screen.height / window.screen.width;
                let limit =  window.screen.height === window.screen.availHeight ? 1.8 : 1.65; // 临界判断值

                return rate > limit ? "126px" : "90px";
            }
        },
        beforeCreate() {
            let that = this;
            let vCourseId = parseInt(that.$route.query.courseId);
            let isIos = that.isAppIos() ? 1 : 0;
            let url = "success/getHomeInfo2/" + vCourseId + "/0/" + isIos;
            window.console.log(url);

            that.$axios.get(url).then((response) => {
                that.objSuccessCourseHomeInfo = response.data;

                that.objSuccessCourseHomeInfo.groupLesson.forEach((item) => {
                    item.lessonArray.forEach((itemLesson) => {
                        if (that.getCount(itemLesson.finish) === 0 && that.selectedLessonPk === 0) {
                            that.selectedLessonPk = itemLesson.pk;
                        }
                    });
                });
            }).catch(function (error) {
                window.console.log(error)
            });
        }
    }
</script>
<style scoped>
    .imgLazyLoadHead {
        position: relative;
        padding: 0px;
    }
    .imgLazyLoadHead img {
        width: 100%;
        margin: auto;
    }
    .lesson_introduce {
        text-align: center;
    }
    .lesson_introduce_content {
        display: inline-block;
        height:30px;
        margin-top: 20px;
        margin-bottom: 10px;
    }
    .lesson_introduce .lesson_introduce_content img {
        float: left;
        width: 30px;
        margin-right: 5px;
    }
    .lesson_introduce .lesson_introduce_content div {
        float: left;
        font-size: 20px;
        font-weight: bold;
    }
    .course_list_content {
        height: auto;
    }
    .clear {
        clear: both;
        line-height: 0;
        font-size: 0;
        height: 0;
        over-flow: hidden;
    }
    .tab_title {
        font-size: 15px;
        font-weight: bold;
    }
    /*课程列表样式*/
    .group_lesson_item {

    }
    .group_lesson_item .group_lesson_title {
        text-align: center;
        padding-top: 5px;
        padding-bottom: 5px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }
    .group_lesson_item .group_lesson_title .chinese {
        font-size: 25px;
        font-weight: bold;
    }
    .group_lesson_item .group_lesson_title .english {
        font-size: 15px;
    }
    .lesson_list_bottom {
        height: 80px;
    }
    .bottom_tool {
        position: fixed;
        background-color: #f4f4f4;
        width: 100%;
        z-index: 10000;
        bottom: 0;
        height: 50px;
    }
    .tabbar_buy {
        display: flex;
        height: 50px;
        background-color: #ff505a;
        width: 100%;
        z-index: 10000;
        align-items: center;
        justify-content: center;
    }
    .tabbar_buy span {
        color: white;
        font-size: 17px;
        text-align: center;

    }
    .tabbar_buy .go {
        position: absolute;
        height: 26px;
        line-height: 26px;
        right: 15px;
        background-color: white;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 13px;
        color: #ff505a;
        text-align: center;
        border-radius: 13px;
        -webkit-border-radius: 13px;
        -moz-border-radius: 13px;
    }

    .all_lesson {
        margin-top:40px;
        text-align: center;
    }
    .all_lesson .all_lesson_line {
        width: 56px;
        height: 1px;
        display: inline-block;
        vertical-align: middle;
    }
    .all_lesson .all_lesson_title {
        font-size: 15px;
        display: inline-block;
    }
</style>
